import {Component, OnInit} from '@angular/core';
@Component({
  selector: 'app-report-dispatch',
  templateUrl: './report-dispatch.component.html',
  styleUrls: ['./report-dispatch.component.scss']
})
export class ReportDispatchComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/report-dispatch/report-dispatch.component.ts